import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { cleanHTMLPartially, newLineToBr } from '@app/shared/utils/utils';

import { IEmployeeObservations } from '../../manage-vacations.interface';

@Component({
  selector: 'app-observations-card',
  templateUrl: './observations-card.component.html',
  styleUrls: ['./observations-card.component.scss']
})
export class ObservationsCardComponent implements OnInit {
  @Input() observations!: IEmployeeObservations;
  @Input() canEdit!: boolean;

  content!: string;

  hasInitialObservations = false;
  userModified = false;
  disableDelete = true;
  disableSend = true;

  @Output() actionClicked: EventEmitter<IEmployeeObservations> = new EventEmitter<IEmployeeObservations>();

  ngOnInit() {
    this.content = newLineToBr(this.observations?.content);
    this.initializeButtons();
  }

  onObservationsChange() {
    this.userModified = true;
    this.checkDeleteButtonStatus();
    this.checkSendButtonStatus();
  }

  checkDeleteButtonStatus() {
    this.disableDelete = !this.hasInitialObservations || !this.content?.length;
  }

  checkSendButtonStatus() {
    this.disableSend = !this.content?.length || !this.userModified;
  }

  initializeButtons() {
    this.hasInitialObservations = Boolean(this.observations?.content?.length);
    this.checkDeleteButtonStatus();
    this.checkSendButtonStatus();
  }

  onActionClicked(sendValue: boolean) {
    const contentFormated = cleanHTMLPartially(this.content);
    this.content = newLineToBr(this.content);

    this.observations = {
      id: this.observations?.id,
      content: contentFormated
    };

    if (!sendValue) {
      this.observations.content = '';
      this.content = '';
    }

    this.userModified = false;
    this.initializeButtons();

    this.actionClicked.emit(this.observations);
  }
}
